import { Button, dialog } from "nq-component";
import BaseFormPresenter from "../../../../../../components/common/BaseFormPresenter";
import { createNotification } from "../../../../../../createNotification";
import {
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
class MonetizationRequestFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }
  DialogConfirmation(status) {
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>{status}</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Click Confirm to continue!
            </p>
            <hr />
          </div>
          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={async () => {
                this.submitData(status);
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  async submitData(status) {
    const { stats, selectedType, employee, acl, ...rest } =
      this.view.state.object;

    const submitData = {
      stats: status,
      selectedType: this.view.state.selectedType,
      id: this.view.getObjectId(),
      employee: { id: employee.id },
      ...rest,
    };
    await upsertUseCase().execute("monetization_request", submitData);
    // if (status === "Approved") {
    //   await upsertUseCase().execute("leave_cred", updateData);
    // }
    dialog.close();
    this.showSuccess("Successfully Approved");
    const NOTIFICATION_MESSAGE = "Your Monetization Request has been approved!";
    const NOTIFICATION_RECEIVER = [submitData.employee.id];
    const NOTIFICATION_REDIRECT = "lmanagement";

    createNotification(
      NOTIFICATION_MESSAGE,
      NOTIFICATION_RECEIVER,
      NOTIFICATION_REDIRECT
    );
    // } else {
    //   dialog.close();
    //   this.showError("Insufficient Credits");
    // }
  }
}

export default MonetizationRequestFormPresenter;
